import styled from 'styled-components';
import {transition} from 'helpers/css';
import {darken, lighten} from 'polished';

export const Wrapper = styled.div`
  ${transition()};
  
  cursor: grab;
  position: relative;
  margin: 0 6px 6px 0;
  padding: 6px 10px 6px 22px;
  border-radius: 5px;
  box-sizing: border-box;
  background: ${({theme}) => `
    ${theme.variables.accentColor};
  `};
  
  user-select: none;
  line-height: 16px;
  font-size: 12px;
  
  &:before {
    content: "";
    
    position: absolute;
    top: 0;
    bottom: 0;
    left: 10px;
    
    display: grid;
    margin: auto;
    height: 10px;
    width: 6px;
    
    background-image: url("data:image/svg+xml,%3Csvg width='6' height='10' viewBox='0 0 6 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='1.0163' cy='1.0163' r='1.0163' fill='white'/%3E%3Ccircle cx='1.0163' cy='4.99969' r='1.0163' fill='white'/%3E%3Ccircle cx='1.0163' cy='8.98407' r='1.0163' fill='white'/%3E%3Ccircle cx='4.35614' cy='1.0163' r='1.0163' fill='white'/%3E%3Ccircle cx='4.35614' cy='4.99969' r='1.0163' fill='white'/%3E%3Ccircle cx='4.35614' cy='8.98407' r='1.0163' fill='white'/%3E%3C/svg%3E%0A");
  }
  
  &:hover {
    background: ${({theme}) => `
      ${lighten(.08, theme.variables.accentColor)};
    `};
  }
`;
